import * as actionTypes from './actionTypes';
import gtagEvent from '../../services/gtagEvent';

export const getLabels = () => {
  return { type: actionTypes.GET_LABELS };
};

export const getLabelsStart = () => {
  return { type: actionTypes.GET_LABELS_START };
};

export const getLabelsSuccess = (labels) => {
  gtagEvent(actionTypes.GET_LABELS_SUCCESS);
  return { type: actionTypes.GET_LABELS_SUCCESS, payload: { labels } };
};

export const getLabelsFail = (error) => {
  gtagEvent(actionTypes.GET_LABELS_FAIL);
  return { type: actionTypes.GET_LABELS_FAIL, payload: { error } };
};

export const createLabel = (label) => {
  return { type: actionTypes.CREATE_LABEL, payload: { label } };
};

export const createLabelStart = () => {
  return { type: actionTypes.CREATE_LABEL_START };
};

export const createLabelSuccess = () => {
  gtagEvent(actionTypes.CREATE_LABEL_SUCCESS);
  return { type: actionTypes.CREATE_LABEL_SUCCESS };
};

export const createLabelFail = (error) => {
  gtagEvent(actionTypes.CREATE_LABEL_FAIL);
  return { type: actionTypes.CREATE_LABEL_FAIL, payload: { error } };
};

export const updateLabel = (label) => {
  return { type: actionTypes.UPDATE_LABEL, payload: { label } };
};

export const updateLabelStart = () => {
  return { type: actionTypes.UPDATE_LABEL_START };
};

export const updateLabelSuccess = () => {
  gtagEvent(actionTypes.UPDATE_LABEL_SUCCESS);
  return { type: actionTypes.UPDATE_LABEL_SUCCESS };
};

export const updateLabelFail = (error) => {
  gtagEvent(actionTypes.UPDATE_LABEL_FAIL);
  return { type: actionTypes.UPDATE_LABEL_FAIL, payload: { error } };
};

export const removeLabel = (id) => {
  return { type: actionTypes.REMOVE_LABEL, payload: { id } };
};

export const removeLabelStart = () => {
  return { type: actionTypes.REMOVE_LABEL_START };
};

export const removeLabelSuccess = () => {
  gtagEvent(actionTypes.REMOVE_LABEL_SUCCESS);
  return { type: actionTypes.REMOVE_LABEL_SUCCESS };
};

export const removeLabelFail = (error) => {
  gtagEvent(actionTypes.REMOVE_LABEL_FAIL);
  return { type: actionTypes.REMOVE_LABEL_FAIL, payload: { error } };
};
